import React, { ReactNode } from "react";

import LinkButton from "../../../ActionsSelectors/Button/LinkButton/LinkButton";
import SvgIcon from "../../../Icons/SvgIcon";

import { DeleteIcon, HeartIconEmpty } from "../../../../icons";

interface IShopingBagProductActions {
  isRemoveAvailable?: boolean;
  isFavoriteAvailable?: boolean;
  labels: {
    removeButton?: ReactNode;
    moveToFavouritesButton?: ReactNode;
  };
  onItemRemove?: () => void;
  onFavouriteAdd?: () => void;
}

const ShopingBagProductActions = ({
  isRemoveAvailable = true,
  isFavoriteAvailable,
  labels,
  onItemRemove,
  onFavouriteAdd,
}: IShopingBagProductActions) => {
  return (
    <div className="product-actions">
      {isRemoveAvailable && (
        <div
          data-testid="ShoppingBag__remove"
          className="button-link--wrapper cursor-pointer me-7"
          onClick={onItemRemove}
        >
          <SvgIcon icon={DeleteIcon} />
          <LinkButton>{labels.removeButton ?? ``}</LinkButton>
        </div>
      )}
      {isFavoriteAvailable && (
        <div
          data-testid="ShoppingBag__favourite"
          className="button-link--wrapper cursor-pointer"
          onClick={onFavouriteAdd}
        >
          <SvgIcon icon={HeartIconEmpty} />
          <LinkButton>{labels.moveToFavouritesButton ?? ``}</LinkButton>
        </div>
      )}
    </div>
  );
};

export default ShopingBagProductActions;
